// extracted by mini-css-extract-plugin
module.exports = {"active":"navbar_active__uT_Td","linkColor":"navbar_linkColor__1WkCT","headerStyle":"navbar_headerStyle__1sP5Q","navStyle":"navbar_navStyle__174eE"};